import { AfterViewInit, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { MovieModel } from 'src/app/core/interfaces/movie.model';
import { environment } from 'src/environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { HelperService } from 'src/app/core/services/helper.service';
import { Router } from '@angular/router';
import { ParameterModel } from 'src/app/core/interfaces/parameter.model';
import { ParametersService } from 'src/app/core/services/parameters.service';

@Component({
  selector: 'app-ui-slideshow',
  templateUrl: './ui-slideshow.component.html',
  styleUrls: ['./ui-slideshow.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class UiSlideshowComponent implements OnInit, AfterViewInit {
  @Input() movies: MovieModel[];


  swiperConfig: SwiperConfigInterface;

  swiperIndex = 0;

  PARAMS: ParameterModel;

  constructor(public san: DomSanitizer, private helperService: HelperService, private router: Router, private parametersService: ParametersService) { }

  banners = [];

  loaded = false;

  async ngOnInit() {

    await this.parametersService.getAllParameters().then((res) => {
      this.PARAMS = res;
    });

    this.movies.forEach(async (movie) => {
      if (movie.isOnline && movie.pictures.length > 0) {
        let picture = movie.pictures.find((picture) => picture.isDefault === true);
        console.log("-------------------");
        console.log(movie.title, movie.pictures, environment.apiEndpoint + picture?.pictureLink, picture);
        console.log("-------------------");
        let base64 = await this.helperService.getBase64ImageFromUrl(environment.apiEndpoint + picture?.pictureLink);

        //Chequeos cocarda
        let esEstreno = false;
        let esCinema = false;
        let isFree = false;

        if (movie.paymentOption == 0) {
          isFree = true;
        }
        if (!isFree) {
          esEstreno = movie.categories.find((c) => {
            return c.id === parseInt(this.PARAMS.ESTRENOS_ID.value);
          }) ? true : false;

          if (!esEstreno) {
            esCinema = movie.categories.find((m) => {
              return m.id === parseInt(this.PARAMS.CINEMA_ID.value);
            }) ? true : false;
          }
        }

        this.banners.push({
          pictureLink: environment.apiEndpoint + picture.pictureLink,
          title: movie.title,
          synopsis: movie.synopsis,
          url: '/movie/' + movie.id,
          base64Img: base64,
          isFree: isFree,
          esEstreno: esEstreno,
          esCinema: esCinema
        });
        this.loaded = true;
      }
    });

    this.swiperConfig = {
      slidesPerView: "auto",
      centeredSlides: false,
      spaceBetween: 0,
      pagination: true,
      navigation: true,
    }

  }


  ngAfterViewInit(): void {

  }

  onClickInfo($event: MouseEvent, banner: any) {
    $event.preventDefault();
    this.router.navigateByUrl(banner.url);
  }

}
